const alwaysEmptyString = () => '';

export default alwaysEmptyString;
